(() => {
  const FILTER_VERSION = '1.0.0';
  const PRODUCT_GRID_SELECTOR = '#product-grid';
  const FILTER_CONTAINER_SELECTOR = '.facets-container[data-collection-handle]';

  const materialDefinitions = [
    { id: 'polyester', label: 'Polyester', pattern: /\bpolyester\b/i },
    { id: 'linen', label: 'Linen', pattern: /\blinen\b/i },
    { id: 'faux-fur', label: 'Faux Fur', pattern: /faux[^.]{0,24}fur|rabbit[^.]{0,16}fur/i },
    { id: 'oxford-fabric', label: 'Oxford Fabric', pattern: /\boxford\b/i },
    { id: 'synthetic-leather', label: 'Synthetic Leather', pattern: /synthetic[- ]?leather|\bpu[- ]?(?:synthetic[- ]?)?leather\b/i },
    { id: 'sisal-fiber', label: 'Sisal Fiber', pattern: /\bsisal\b/i },
  ];

  const priceDefinitions = [
    { id: 'under-10', label: 'Less Than $10', matches: (price) => price < 10 },
    { id: '10-20', label: '$10–$20', matches: (price) => price >= 10 && price < 20 },
    { id: '20-30', label: '$20–$30', matches: (price) => price >= 20 && price < 30 },
    { id: '30-40', label: '$30–$40', matches: (price) => price >= 30 && price < 40 },
    { id: '40-75', label: '$40–$75', matches: (price) => price >= 40 && price < 75 },
    { id: '75-100', label: '$75–$100', matches: (price) => price >= 75 && price <= 100 },
    { id: 'over-100', label: 'More Than $100', matches: (price) => price > 100 },
  ];

  const translations = {
    en: {
      filter: 'Filter:',
      size: 'Size',
      material: 'Material',
      price: 'Price',
      clear: 'Clear all',
      noResults: 'No products match these filters.',
      product: 'product',
      products: 'products',
      materialLabels: {},
      less: 'Less Than $10',
      more: 'More Than $100',
    },
    it: {
      filter: 'Filtra:',
      size: 'Taglia',
      material: 'Materiale',
      price: 'Prezzo',
      clear: 'Cancella tutto',
      noResults: 'Nessun prodotto corrisponde a questi filtri.',
      product: 'prodotto',
      products: 'prodotti',
      materialLabels: {
        polyester: 'Poliestere',
        linen: 'Lino',
        'faux-fur': 'Pelliccia sintetica',
        'oxford-fabric': 'Tessuto Oxford',
        'synthetic-leather': 'Pelle sintetica',
        'sisal-fiber': 'Fibra di sisal',
      },
      less: 'Meno di $10',
      more: 'Più di $100',
    },
    ja: {
      filter: '絞り込み：',
      size: 'サイズ',
      material: '素材',
      price: '価格',
      clear: 'すべて解除',
      noResults: '選択した条件に一致する商品はありません。',
      product: '商品',
      products: '商品',
      materialLabels: {
        polyester: 'ポリエステル',
        linen: 'リネン',
        'faux-fur': 'フェイクファー',
        'oxford-fabric': 'オックスフォード生地',
        'synthetic-leather': '合成皮革',
        'sisal-fiber': 'サイザル繊維',
      },
      less: '$10未満',
      more: '$100超',
    },
    fr: {
      filter: 'Filtrer :',
      size: 'Taille',
      material: 'Matière',
      price: 'Prix',
      clear: 'Tout effacer',
      noResults: 'Aucun produit ne correspond à ces filtres.',
      product: 'produit',
      products: 'produits',
      materialLabels: {
        polyester: 'Polyester',
        linen: 'Lin',
        'faux-fur': 'Fausse fourrure',
        'oxford-fabric': 'Tissu Oxford',
        'synthetic-leather': 'Cuir synthétique',
        'sisal-fiber': 'Fibre de sisal',
      },
      less: 'Moins de $10',
      more: 'Plus de $100',
    },
    es: {
      filter: 'Filtrar:',
      size: 'Talla',
      material: 'Material',
      price: 'Precio',
      clear: 'Borrar todo',
      noResults: 'Ningún producto coincide con estos filtros.',
      product: 'producto',
      products: 'productos',
      materialLabels: {
        polyester: 'Poliéster',
        linen: 'Lino',
        'faux-fur': 'Piel sintética',
        'oxford-fabric': 'Tejido Oxford',
        'synthetic-leather': 'Cuero sintético',
        'sisal-fiber': 'Fibra de sisal',
      },
      less: 'Menos de $10',
      more: 'Más de $100',
    },
    de: {
      filter: 'Filter:',
      size: 'Größe',
      material: 'Material',
      price: 'Preis',
      clear: 'Alle löschen',
      noResults: 'Keine Produkte entsprechen diesen Filtern.',
      product: 'Produkt',
      products: 'Produkte',
      materialLabels: {
        polyester: 'Polyester',
        linen: 'Leinen',
        'faux-fur': 'Kunstfell',
        'oxford-fabric': 'Oxford-Gewebe',
        'synthetic-leather': 'Kunstleder',
        'sisal-fiber': 'Sisalfaser',
      },
      less: 'Unter $10',
      more: 'Über $100',
    },
  };

  const localeKey = () => {
    const locale = (document.documentElement.lang || 'en').toLowerCase();
    return Object.keys(translations).find((key) => locale.startsWith(key)) || 'en';
  };

  const decodeHtml = (html) => {
    const element = document.createElement('div');
    element.innerHTML = html || '';
    return element.textContent || '';
  };

  const handleFromCard = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  const valuesFromUrl = (key, allowed) => {
    const values = new URLSearchParams(window.location.search)
      .getAll(key)
      .flatMap((value) => value.split(','))
      .filter((value) => allowed.includes(value));
    return new Set(values);
  };

  const productMatchesPrice = (product, rangeId) => {
    const range = priceDefinitions.find((item) => item.id === rangeId);
    return Boolean(range && product.prices.some(range.matches));
  };

  const productMatchesState = (product, state) => {
    const sizeMatch =
      state.size.size === 0 ||
      [...state.size].some((value) => product.sizes.includes(value));
    const materialMatch =
      state.material.size === 0 ||
      [...state.material].some((value) => product.materials.includes(value));
    const priceMatch =
      state.price.size === 0 ||
      [...state.price].some((value) => productMatchesPrice(product, value));
    return sizeMatch && materialMatch && priceMatch;
  };

  const enrichProduct = (product) => {
    const searchableText = [
      product.title,
      ...(product.tags || []),
      decodeHtml(product.body_html),
    ].join(' ');
    const sizeOption = (product.options || []).find(
      (option) => option.name.toLowerCase() === 'size'
    );

    return {
      handle: product.handle,
      sizes: (sizeOption?.values || []).filter((value) => ['S', 'M', 'L'].includes(value)),
      materials: materialDefinitions
        .filter((definition) => definition.pattern.test(searchableText))
        .map((definition) => definition.id),
      prices: (product.variants || [])
        .map((variant) => Number.parseFloat(variant.price))
        .filter(Number.isFinite),
    };
  };

  const optionCount = (products, group, value) =>
    products.filter((product) => {
      if (group === 'size') return product.sizes.includes(value);
      if (group === 'material') return product.materials.includes(value);
      return productMatchesPrice(product, value);
    }).length;

  const createFilterGroup = ({
    group,
    label,
    options,
    products,
    state,
    copy,
    open,
    instance,
  }) => {
    const details = document.createElement('details');
    details.className = 'dp-filter-group';
    details.dataset.group = group;
    details.open = open;

    const summary = document.createElement('summary');
    summary.innerHTML = `<span>${label}</span><span class="dp-filter-selected" aria-hidden="true"></span><span class="dp-filter-caret" aria-hidden="true"></span>`;
    details.append(summary);

    const list = document.createElement('div');
    list.className = 'dp-filter-options';

    options.forEach((option) => {
      const count = optionCount(products, group, option.id);
      const row = document.createElement('label');
      row.className = `dp-filter-option${count === 0 ? ' is-disabled' : ''}`;
      const inputId = `dp-${instance}-${group}-${option.id}`;
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.id = inputId;
      input.className = 'dp-filter-input';
      input.dataset.group = group;
      input.value = option.id;
      input.checked = state[group].has(option.id);
      input.disabled = count === 0;

      const box = document.createElement('span');
      box.className = 'dp-filter-box';
      box.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'dp-filter-option-label';
      let optionLabel = option.label;
      if (group === 'material') {
        optionLabel = copy.materialLabels[option.id] || option.label;
      } else if (group === 'price' && option.id === 'under-10') {
        optionLabel = copy.less;
      } else if (group === 'price' && option.id === 'over-100') {
        optionLabel = copy.more;
      }
      text.textContent = optionLabel;
      const countElement = document.createElement('span');
      countElement.className = 'dp-filter-count';
      countElement.textContent = `(${count})`;

      row.htmlFor = inputId;
      row.append(input, box, text, countElement);
      list.append(row);
    });

    details.append(list);
    return details;
  };

  const createFilterPanel = ({ products, state, copy, mobile }) => {
    const root = document.createElement(mobile ? 'details' : 'div');
    root.className = mobile
      ? 'dp-collection-filters dp-mobile-filters'
      : 'dp-collection-filters dp-desktop-filters';
    root.dataset.dpFilterVersion = FILTER_VERSION;
    if (mobile) {
      const mobileSummary = document.createElement('summary');
      mobileSummary.className = 'dp-mobile-filter-toggle';
      mobileSummary.innerHTML = `<span>${copy.filter.replace(':', '')}</span><span class="dp-filter-caret" aria-hidden="true"></span>`;
      root.append(mobileSummary);
    }

    const inner = document.createElement('div');
    inner.className = 'dp-filter-panel';

    const heading = document.createElement('div');
    heading.className = 'dp-filter-heading';
    heading.innerHTML = `<span>${copy.filter}</span>`;
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'dp-filter-clear';
    clear.textContent = copy.clear;
    heading.append(clear);
    inner.append(heading);

    const sizeOptions = ['S', 'M', 'L'].map((value) => ({ id: value, label: value }));
    inner.append(
      createFilterGroup({
        group: 'size',
        label: copy.size,
        options: sizeOptions,
        products,
        state,
        copy,
        open: !mobile,
        instance: mobile ? 'mobile' : 'desktop',
      }),
      createFilterGroup({
        group: 'material',
        label: copy.material,
        options: materialDefinitions,
        products,
        state,
        copy,
        open: false,
        instance: mobile ? 'mobile' : 'desktop',
      }),
      createFilterGroup({
        group: 'price',
        label: copy.price,
        options: priceDefinitions,
        products,
        state,
        copy,
        open: false,
        instance: mobile ? 'mobile' : 'desktop',
      })
    );

    root.append(inner);
    return root;
  };

  const initFilters = async () => {
    if (!window.location.pathname.includes('/collections/')) return;
    const container = document.querySelector(FILTER_CONTAINER_SELECTOR);
    const grid = document.querySelector(PRODUCT_GRID_SELECTOR);
    if (!container || !grid || container.dataset.dpFiltersLoading === 'true') return;
    if (container.querySelector('.dp-collection-filters')) return;
    container.dataset.dpFiltersLoading = 'true';

    try {
      const handle =
        container.dataset.collectionHandle ||
        window.location.pathname.split('/collections/')[1]?.split('/')[0];
      if (!handle) return;

      const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Products request failed: ${response.status}`);
      const payload = await response.json();
      const products = (payload.products || []).map(enrichProduct);
      const productMap = new Map(products.map((product) => [product.handle, product]));
      const copy = translations[localeKey()];
      const state = {
        size: valuesFromUrl('dp_size', ['S', 'M', 'L']),
        material: valuesFromUrl(
          'dp_material',
          materialDefinitions.map((item) => item.id)
        ),
        price: valuesFromUrl(
          'dp_price',
          priceDefinitions.map((item) => item.id)
        ),
      };

      const desktop = createFilterPanel({ products, state, copy, mobile: false });
      const desktopForm = container.querySelector('#FacetFiltersForm');
      if (desktopForm) desktopForm.replaceChildren(desktop);

      const mobile = createFilterPanel({ products, state, copy, mobile: true });
      const nativeMobile = container.querySelector('.mobile-facets__wrapper');
      if (nativeMobile) nativeMobile.insertAdjacentElement('beforebegin', mobile);
      else container.append(mobile);

      const emptyState = document.createElement('div');
      emptyState.className = 'dp-filter-empty';
      emptyState.hidden = true;
      emptyState.innerHTML = `<p>${copy.noResults}</p><button type="button" class="button button--secondary dp-filter-empty-clear">${copy.clear}</button>`;
      grid.insertAdjacentElement('afterend', emptyState);

      const cards = [...grid.querySelectorAll(':scope > li, :scope > .grid__item')];
      const hasSelections = () =>
        state.size.size + state.material.size + state.price.size > 0;

      const syncControls = () => {
        document.querySelectorAll('.dp-filter-input').forEach((input) => {
          input.checked = state[input.dataset.group].has(input.value);
        });
        document.querySelectorAll('.dp-filter-group').forEach((details) => {
          const selected = state[details.dataset.group].size;
          const badge = details.querySelector('.dp-filter-selected');
          badge.textContent = selected ? `(${selected})` : '';
        });
        document.querySelectorAll('.dp-filter-clear').forEach((button) => {
          button.hidden = !hasSelections();
        });
      };

      const updateUrl = () => {
        const url = new URL(window.location.href);
        ['dp_size', 'dp_material', 'dp_price'].forEach((key) => url.searchParams.delete(key));
        [...state.size].forEach((value) => url.searchParams.append('dp_size', value));
        [...state.material].forEach((value) => url.searchParams.append('dp_material', value));
        [...state.price].forEach((value) => url.searchParams.append('dp_price', value));
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      };

      const applyFilters = () => {
        let visibleCount = 0;
        cards.forEach((card) => {
          const product = productMap.get(handleFromCard(card));
          const visible = !hasSelections() || Boolean(product && productMatchesState(product, state));
          card.hidden = !visible;
          card.setAttribute('aria-hidden', String(!visible));
          if (visible) visibleCount += 1;
        });

        emptyState.hidden = visibleCount !== 0;
        const countText = document.querySelector('.product-count__text');
        if (countText) {
          countText.textContent = `${visibleCount} ${visibleCount === 1 ? copy.product : copy.products}`;
        }
        syncControls();
        updateUrl();
      };

      const clearFilters = () => {
        Object.values(state).forEach((set) => set.clear());
        applyFilters();
      };

      container.querySelectorAll('.dp-filter-input').forEach((input) => {
        input.addEventListener('change', () => {
          const selected = state[input.dataset.group];
          if (input.checked) selected.add(input.value);
          else selected.delete(input.value);
          applyFilters();
        });
      });
      container.querySelectorAll('.dp-filter-clear').forEach((button) => {
        button.addEventListener('click', clearFilters);
      });
      emptyState.querySelector('.dp-filter-empty-clear')?.addEventListener('click', clearFilters);

      container.dataset.dpFiltersLoading = 'false';
      document.body.classList.add('dp-custom-filters-ready');
      applyFilters();
    } catch (error) {
      container.dataset.dpFiltersLoading = 'false';
      console.warn('DearPet collection filters could not initialize.', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters, { once: true });
  } else {
    initFilters();
  }

  let refreshTimer;
  const observer = new MutationObserver(() => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(initFilters, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
